import type { IntakeSpec, PrintingReplacementDetails } from '@shared/types';
import type { Part, Joint, Feature } from '@shared/spec';

function getDetails(intake: IntakeSpec): PrintingReplacementDetails {
  return intake.details as PrintingReplacementDetails;
}

export function parts(intake: IntakeSpec): Part[] {
  const d = getDetails(intake);
  return [
    {
      id: 'body',
      name: d.replacingType,
      kind: 'custom',
      materialId: 'mat-primary',
      openscadSnippet: `// ${d.replacingType} replacement geometry placeholder`,
      boundingBox: {
        w: intake.core.size?.length ?? 50,
        d: intake.core.size?.width ?? 50,
        h: intake.core.size?.height ?? 30,
      },
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['replacement'],
      paramRefs: [],
    },
  ];
}

export function joints(_intake: IntakeSpec): Joint[] {
  return [];
}

export function features(intake: IntakeSpec): Feature[] {
  if (intake.qualityLevel === 'draft' || intake.qualityLevel === 'standard') return [];

  const d = getDetails(intake);
  const out: Feature[] = [];

  const bboxH = intake.core.size?.height ?? 30;
  const bboxW = intake.core.size?.length ?? 50;

  // Edge chamfer on bottom
  out.push({
    id: 'edge_chamfer',
    partId: 'body',
    kind: 'edge_treatment',
    treatment: 'chamfer',
    amount: 0.5,
    scope: 'bottom',
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    paramRefs: [],
  });

  // Fastener interface
  const fi = d.fastenerInterface;
  if (fi === 'screw_M3' || fi === 'screw_M4' || fi === 'screw_M5') {
    const size = fi.replace('screw_', '') as 'M3' | 'M4' | 'M5';
    out.push({
      id: 'fastener_hole',
      partId: 'body',
      kind: 'screw_hole',
      size,
      length: bboxH,
      head: 'flat',
      axis: 'z',
      thread: false,
      teardrop: false,
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      paramRefs: [],
    });
  }
  // snap_fit: snap_fit feature kind is B2 rest, deferred — emit nothing for now.
  //

  // Reinforcement
  if (d.reinforcement === 'ribs') {
    out.push({
      id: 'rib_1',
      partId: 'body',
      kind: 'rib',
      length: bboxW * 0.8,
      height: 3,
      thickness: 1.5,
      axis: 'x',
      position: [0, -4, 0],
      rotation: [0, 0, 0],
      paramRefs: [],
    });
    out.push({
      id: 'rib_2',
      partId: 'body',
      kind: 'rib',
      length: bboxW * 0.8,
      height: 3,
      thickness: 1.5,
      axis: 'x',
      position: [0, 4, 0],
      rotation: [0, 0, 0],
      paramRefs: [],
    });
  } else if (d.reinforcement === 'metal_insert') {
    out.push({
      id: 'metal_insert',
      partId: 'body',
      kind: 'insert_hole',
      insertType: 'press_fit',
      outerDiameter: 8,
      depth: 10,
      axis: 'z',
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      paramRefs: [],
    });
  }

  return out;
}
